module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/corporate-business-15ba32dc7fc43162bf342352f16417d4.jpg";